<div
    class="topbar flex items-center px-4 py-2 bg-white dark:bg-slate-800 dark:text-white shadow-sm rounded-xl mt-4 m-4 absolute">
    <!-- Mobile Menu Button -->
    <button (click)="onToggleSidebar()"
        class="flex justify-center items-center w-10 h-10 rounded-full hover:bg-primary/10 transition cursor-pointer">
        <span class="iconify text-xl transition-transform" data-icon="tabler:menu-2"></span>
    </button>
    <!-- Notification Button -->
    <div *ngIf="businessContext.hasContext()" class="relative menu-trigger">
        <button (click)="toggleMenu('menu')"
            class="flex items-center justify-center w-10 h-10 rounded-full hover:bg-primary/10 transition cursor-pointer"
            aria-label="Notifications">
            <span class="iconify text-xl" data-icon="tabler:bell"></span>
            <span *ngIf="newNotificationsCount() > 0"
                class="absolute top-0 right-0 inline-flex items-center justify-center w-4 h-4 text-xs font-bold text-white bg-red-500 rounded-full">
                {{ newNotificationsCount() }}
            </span>
        </button>
        <!-- Notification Dropdown Menu -->
        <div *ngIf="activeMenu === 'menu'"
            class="absolute left-0 top-full mt-5 w-80 bg-white dark:bg-slate-800 dark:text-white rounded-2xl shadow-xl border border-gray-100 dark:border-slate-700 z-50 overflow-hidden animate-in fade-in slide-in-from-top-1">

            <!-- ── HEADER ─────────────────────────────── -->
            <div
                class="px-4 py-3 border-b border-gray-100 dark:border-slate-700 flex items-center justify-between bg-gray-50/50 dark:bg-slate-800/50">
                @if (notifView() === 'current') {
                <p class="text-sm font-black uppercase tracking-wider text-slate-500">Notificaciones</p>
                <div class="flex items-center gap-2">
                    <span *ngIf="newNotificationsCount() > 0"
                        class="bg-primary text-white px-2 py-0.5 rounded-full text-[10px] font-bold">
                        {{ newNotificationsCount() }} Nuevas
                    </span>
                    <!-- Botón historial -->
                    <button (click)="toggleNotifView()" title="Ver historial"
                        class="flex items-center justify-center w-7 h-7 rounded-lg hover:bg-primary/10 text-slate-400 hover:text-primary transition cursor-pointer">
                        <span class="iconify text-base" data-icon="tabler:history"></span>
                    </button>
                </div>
                } @else {
                <div class="flex items-center gap-2">
                    <span class="iconify text-primary" data-icon="tabler:history"></span>
                    <p class="text-sm font-black uppercase tracking-wider text-primary">Historial (90 días)</p>
                </div>
                <!-- X para volver a actuales -->
                <button (click)="toggleNotifView()" title="Volver a actuales"
                    class="flex items-center justify-center w-7 h-7 rounded-lg hover:bg-red-50 text-slate-400 hover:text-red-500 transition cursor-pointer">
                    <span class="iconify text-base" data-icon="tabler:x"></span>
                </button>
                }
            </div>

            <!-- ── VISTA ACTUAL ───────────────────────── -->
            @if (notifView() === 'current') {
            <div class="max-h-96 overflow-y-auto no-scrollbar">
                <!-- Empty state -->
                <div *ngIf="notifications().length === 0" class="px-4 py-10 text-center">
                    <span class="iconify text-4xl text-gray-200 mb-2 mx-auto block" data-icon="tabler:bell-off"></span>
                    <p class="text-xs text-gray-400">No hay notificaciones</p>
                </div>
                <!-- List -->
                <div *ngFor="let notification of notifications()" (click)="markAsRead(notification)"
                    [class.bg-blue-50/40]="!notification.isRead"
                    class="px-4 py-3 cursor-pointer hover:bg-gray-100/50 dark:hover:bg-slate-700/50 border-b border-gray-50 dark:border-slate-700/50 last:border-b-0 transition-colors relative group">

                    <!-- Unread Dot -->
                    <div *ngIf="!notification.isRead"
                        class="absolute left-1 top-1/2 -translate-y-1/2 w-1.5 h-1.5 bg-blue-500 rounded-full shadow-sm shadow-blue-500/50">
                    </div>

                    <!-- Delete individual button -->
                    <button (click)="dismissOne(notification, $event)" [disabled]="dismissingIds().has(notification._id || notification.id || '')"
                        class="absolute top-2 right-2 opacity-0 group-hover:opacity-100 w-5 h-5 flex items-center justify-center rounded-full bg-gray-100 hover:bg-red-100 text-gray-400 hover:text-red-500 transition-all disabled:opacity-50"
                        title="Descartar">
                        <span *ngIf="!dismissingIds().has(notification._id || notification.id || '')" class="iconify text-xs" data-icon="tabler:x"></span>
                        <span *ngIf="dismissingIds().has(notification._id || notification.id || '')" class="iconify animate-spin text-[10px]" data-icon="tabler:loader-2"></span>
                    </button>

                    <div class="flex items-start gap-3 pr-4">
                        <div class="flex-shrink-0">
                            <div [ngClass]="{
                                'bg-green-100 text-green-600 dark:bg-green-500/20': notification.type === 'success',
                                'bg-red-100 text-red-600 dark:bg-red-500/20': notification.type === 'error',
                                'bg-blue-100 text-blue-600 dark:bg-blue-500/20': notification.type === 'info',
                                'bg-yellow-100 text-yellow-600 dark:bg-yellow-500/20': notification.type === 'warning'
                            }" class="w-8 h-8 rounded-lg flex items-center justify-center">
                                <span class="iconify text-lg"
                                    [attr.data-icon]="getNotificationIcon(notification.type)"></span>
                            </div>
                        </div>
                        <div class="flex-1 min-w-0">
                            <div class="flex items-center justify-between mb-0.5">
                                <p class="text-xs font-bold text-gray-900 dark:text-white truncate">{{
                                    notification.title }}</p>
                                <span class="text-[9px] text-gray-400 whitespace-nowrap ml-2">{{ notification.createdAt
                                    | date:'HH:mm' }}</span>
                            </div>
                            <p class="text-[11px] text-gray-500 dark:text-slate-400 leading-relaxed">{{
                                notification.message }}</p>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Footer -->
            <div class="px-4 py-3 border-t border-gray-100 dark:border-slate-700 bg-gray-50/50 dark:bg-slate-800/50">
                <button (click)="clearAll()" [disabled]="isClearing() || notifications().length === 0"
                    class="w-full h-9 flex items-center justify-center bg-primary text-white rounded-xl text-[10px] font-black uppercase tracking-widest hover:bg-primary/90 transition shadow-sm shadow-primary/20 disabled:opacity-70 disabled:cursor-not-allowed">
                    <span *ngIf="!isClearing()">Limpiar todo</span>
                    <div *ngIf="isClearing()" class="flex items-center gap-2">
                        <span class="iconify animate-spin text-sm" data-icon="tabler:loader-2"></span>
                        <span>Limpiando...</span>
                    </div>
                </button>
            </div>
            }

            <!-- ── VISTA HISTORIAL ────────────────────── -->
            @if (notifView() === 'history') {
            <div class="max-h-96 overflow-y-auto no-scrollbar">
                <!-- Loading -->
                @if (historyLoading()) {
                <div class="flex items-center justify-center py-10">
                    <span class="iconify animate-spin text-2xl text-primary" data-icon="tabler:loader-2"></span>
                </div>
                }
                <!-- Empty -->
                @else if (historyNotifications().length === 0) {
                <div class="py-10 text-center">
                    <span class="iconify text-4xl text-gray-200 mb-2 mx-auto block" data-icon="tabler:history"></span>
                    <p class="text-xs text-gray-400">No hay notificaciones eliminadas</p>
                </div>
                }
                <!-- List -->
                @else {
                @for (n of historyNotifications(); track n._id) {
                @if (n.isDismissed) {
                <div class="px-4 py-3 border-b border-gray-50 dark:border-slate-700/50 last:border-b-0 relative group opacity-70">
                    <div class="flex items-start gap-3 pr-10">
                        <div class="flex-shrink-0">
                            <div [ngClass]="{
                                'bg-green-100 text-green-600 dark:bg-green-500/20': n.type === 'success',
                                'bg-red-100 text-red-600 dark:bg-red-500/20': n.type === 'error',
                                'bg-blue-100 text-blue-600 dark:bg-blue-500/20': n.type === 'info',
                                'bg-yellow-100 text-yellow-600 dark:bg-yellow-500/20': n.type === 'warning'
                            }" class="w-8 h-8 rounded-lg flex items-center justify-center">
                                <span class="iconify text-lg" [attr.data-icon]="getNotificationIcon(n.type)"></span>
                            </div>
                        </div>
                        <div class="flex-1 min-w-0">
                            <div class="flex items-center justify-between mb-0.5">
                                <p class="text-xs font-bold text-gray-900 dark:text-white truncate">{{ n.title }}</p>
                                <span class="text-[9px] text-gray-400 whitespace-nowrap ml-2">{{ n.createdAt | date:'dd/MM HH:mm' }}</span>
                            </div>
                            <p class="text-[11px] text-gray-500 dark:text-slate-400 leading-relaxed">{{ n.message }}</p>
                        </div>
                    </div>
                    <!-- Restore button -->
                    <button (click)="restoreOne(n, $event)" title="Restaurar" [disabled]="restoringIds().has(n._id || n.id || '')"
                        class="absolute top-1/2 -translate-y-1/2 right-3 opacity-0 group-hover:opacity-100 w-7 h-7 flex items-center justify-center rounded-full bg-primary/10 hover:bg-primary/20 text-primary transition-all disabled:opacity-50">
                        <span *ngIf="!restoringIds().has(n._id || n.id || '')" class="iconify text-base" data-icon="tabler:restore"></span>
                        <span *ngIf="restoringIds().has(n._id || n.id || '')" class="iconify animate-spin text-sm" data-icon="tabler:loader-2"></span>
                    </button>
                </div>
                }
                }
                <!-- Refresh -->
                <button (click)="loadHistory()"
                    class="w-full py-2.5 text-[10px] font-bold text-primary/60 hover:text-primary flex items-center justify-center gap-1.5 transition-colors border-t border-gray-50 dark:border-slate-700/50">
                    <span class="iconify text-sm" data-icon="tabler:refresh"></span>
                    Actualizar historial
                </button>
                }
            </div>
            }

        </div>
    </div>
    <!-- Theme Toggle -->
    <div class="ml-2">
        <app-theme-toggle></app-theme-toggle>
    </div>
    <!-- Spacer -->
    <div class="flex-1"></div>


    <!-- Profile Dropdown -->
    <div class="flex items-center flex-row">
        <div></div>
        <div class="relative menu-trigger z-50 inset-0">
            <button (click)="toggleMenu('profile')"
                class="flex items-center gap-2 rounded-xl hover:bg-primary/5 transition px-2 py-1.5 cursor-pointer border border-transparent hover:border-slate-200 dark:hover:border-slate-700"
                aria-label="Profile">
                <!-- Avatar Initials -->
                <div
                    class="w-9 h-9 rounded-xl bg-primary text-white flex items-center justify-center font-black text-xs shadow-sm shadow-primary/20">
                    {{ userInitials }}
                </div>
                <!-- Nombre y rol -->
                <div class="hidden md:flex flex-col items-start text-left">
                    <p class="font-semibold text-gray-900 text-xs">{{ userFullName }}</p>
                    <p class="flex items-center text-[9px] mt-1 gap-1 text-gray-500">
                        {{ user?.email }}
                    </p>
                </div>
            </button>
            <!-- Profile Menu -->
            @if(activeMenu === 'profile') {
            <div
                class="absolute right-0 top-full mt-2 w-64 bg-white rounded-lg shadow-lg dark:bg-slate-800 z-1 overflow-hidden">
                <!-- User Info Section -->
                <div class="px-4 py-3 border-b border-gray-100">
                    <div class="flex items-center gap-3">
                        <div
                            class="w-9 h-9 rounded-xl bg-primary text-white flex items-center justify-center font-black text-xs shadow-sm shadow-primary/20">
                            {{ userInitials }}
                        </div>
                        <div>
                            <p class="font-semibold text-gray-900">{{ userFullName }}</p>
                            <p class="flex items-center text-xs mt-1 gap-1 text-gray-500">
                                <span class="iconify" data-icon="tabler:mail"></span>
                                {{ user?.email }}
                            </p>
                        </div>
                    </div>
                </div>
                <!-- Menu Items -->
                <div class="py-1">
                    <button
                        class="flex items-center gap-3 px-4 py-3 text-sm hover:bg-gray-50 w-full text-left transition-colors cursor-pointer"
                        routerLink="/app/profile" (click)="toggleMenu('profile')">
                        <span class="iconify text-lg text-gray-600" data-icon="tabler:user"></span>
                        <span class="text-gray-700">Mi Perfil</span>
                    </button>
                    <button
                        class="flex items-center gap-3 px-4 py-3 text-sm hover:bg-gray-50 w-full text-left transition-colors cursor-pointer"
                        routerLink="/admin/my-profile" (click)="toggleMenu('profile')">
                        <span class="iconify text-lg text-gray-600" data-icon="tabler:settings"></span>
                        <span class="text-gray-700">Configuración</span>
                    </button>
                </div>

                <!-- ── Seccion de Negocio (Solo para usuarios no SuperAdmin) ── -->
                @if (!isSuperAdmin()) {
                    <div class="border-t border-gray-100 dark:border-slate-700 my-1"></div>
                    <div class="px-4 py-2">
                        <p class="text-[9px] font-black uppercase tracking-wider text-slate-500 dark:text-slate-500 mb-1.5">
                            CAMBIAR NEGOCIO</p>

                        <div class="space-y-1 max-h-44 overflow-y-auto no-scrollbar">
                            <!-- Global -->
                            <button (click)="deselectBusiness()"
                                [ngClass]="{'bg-primary/10 text-primary-600 font-black': !businessContext.hasContext(), 'text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700/30': businessContext.hasContext()}"
                                class="w-full flex items-center gap-2 px-2.5 py-1.5 rounded-lg text-xs font-bold transition-colors text-left">
                                <div
                                    class="w-6 h-6 rounded-md bg-slate-200 dark:bg-slate-700 flex items-center justify-center text-slate-500 font-black text-[9px]">
                                    GL
                                </div>
                                <span>Vista Global</span>
                            </button>

                            <!-- Dinámicos -->
                            <button *ngFor="let b of businesses()" (click)="onBusinessChangeDirect(b)"
                                [ngClass]="{'bg-primary/10 text-primary-600 font-black': (b.business?._id || b.business || b._id) === businessContext.business(), 'text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700/30': (b.business?._id || b.business || b._id) !== businessContext.business()}"
                                class="w-full flex items-center gap-2 px-2.5 py-1.5 rounded-lg text-xs font-semibold transition-colors text-left justify-between">
                                <div class="flex items-center gap-2">
                                    <div
                                        class="w-6 h-6 rounded-md bg-blue-500 text-white flex items-center justify-center font-bold text-[9px]">
                                        {{ getBusinessInitials(b.business?.name || b.businessName || b.name) }}
                                    </div>
                                    <span class="truncate max-w-[120px]">{{ b.business?.name || b.businessName || b.name
                                        }}</span>
                                </div>
                                <span *ngIf="(b.business?._id || b.business || b._id) === businessContext.business()"
                                    class="iconify text-primary text-sm" data-icon="solar:check-circle-bold"></span>
                            </button>
                        </div>
                    </div>
                }
                <!-- Logout Section -->
                <div class="flex flex-col w-full p-4">
                    <button (click)="onLogout()"
                        class="w-full text-center py-2.5 bg-red-500 hover:bg-red-600 text-white rounded-xl text-sm font-bold transition">
                        Cerrar sesión
                    </button>
                </div>
            </div>
            }
        </div>
    </div>
</div>